import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#C92042" }}>Brief</span>
            </h2>
            <p>
              Muirfield is a platform for forward-thinking real estate investors
              leading the effort to reinvent and improve private equity
              investing through the use of blockchain technology.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#C92042" }}> 2018</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#C92042" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#C92042" }}> WEBSITE DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
